// BCM-898 · Goods Receipt Dashboard — shared constants
// Source of truth: BCM-898_Slides_and_Actions_v3.xlsx (Action Gate sheet) +
// BCM-898_Goods_Receipt_Dashboard_API_Reference.docx (Appendix B).
//
// SASL batch status IDs, taken from
// temporal-workflows/.../processFlow1-5Workflow.ts and the Action Gate sheet.
// Several statuses mean different things per process flow (39, 47, 49, 55, 56) —
// disambiguated in resolvePendingAction.js from fields already on the row / the
// loaded A2 detail (no processFlowId, frontend-only).
export const STATUS = {
  PRODUCTION_COMPLETE: 3, // PA1 — post-manufacturing documents not received
  CMO_QC_RELEASED: 5, // PA2 — review of low confidence fields
  POST_MFG_VALIDATED: 55, // PA3 review consumption (flag), or PA4 once that's off — the expiry check
  STOCK_CHECK_NOT_REQUIRED: 37, // PA4 — material batch expired
  MATERIAL_NOT_EXPIRED: 38, // PA5 — consumed material not matching BMS PO BoM material
  SPECS_NOT_MATCHING: 40, // PA6 — variance / mismatch approval
  SPECS_APPROVED: 39, // PA7 pre-shipment documents (PF 1-4) / PA8 pre-GRN checks (PF5)
  PRE_SHIPMENT_UPLOADED: 45, // PA2 — pre-shipment low confidence fields
  PRE_SHIPMENT_VALIDATED: 56, // PA8 — pre-IBD (PF1) / pre-GRN (PF2,3,4)
  CMO_ASN_COMPLETED: 47, // PA8 (PF3) / PA12 (PF4)
  PRE_IBD_COMPLETED: 108, // PA9 (IBD)
  PRE_GRN_COMPLETED: 109, // PA9 (GRN)
  PARTIAL_GRN: 60, // PA9 (partial GRN round)
  PARTIAL_IBD: 61, // PA9 (partial IBD round)
  IBD_GENERATED: 48, // PA12 (PF2,3)
  GRN_GENERATED: 49, // PA10 (PF4) / PA12 (PF2,3) / final (PF5)
  BATCH_RELEASED_BY_QA: 46, // PA12 (PF4)
  BATCH_NOT_ACCEPTED: 41, // PA11 — batch QA release rejected
  POST_SHIPMENT_UPLOADED: 50, // PA2 — post-shipment low confidence fields
};

// The pending actions. `dev` records the slide-owner split so the three
// developers know which file is theirs (each action lives in its own file under
// goodsReceipt/actions/).
export const PA = {
  PA1: "PA1", // slide 6      — Uday
  PA2: "PA2", // slide 7      — Uday
  PA3: "PA3", // slides 8-10  — Uday
  PA4: "PA4", // slides 11-12 — Uday
  PA5: "PA5", // slides 13-14 — Uday
  PA6: "PA6", // slides 15-21 — Shekar
  PA7: "PA7", // slide 22     — Shekar
  PA8: "PA8", // slides 23-27 — Shekar
  PA9: "PA9", // slides 28-30 — Lavanya
  PA10: "PA10", // slide 31   — Lavanya
  PA11: "PA11", // slide 32   — Lavanya
  PA12: "PA12", // slide 33   — Lavanya
};

// Document category literals — must match the backend EXACTLY (Slides & Actions
// v3, render logic for slides 6/22/33; API Reference A3).
export const DOC_CATEGORY = {
  POST_MANUFACTURING: "Post-Manufacturing",
  PRE_SHIPMENT: "Pre-Shipment Documents",
  POST_SHIPMENT: "Post-Shipment Documents",
};

// Auto-dismiss window for every success toast on this dashboard (slides 10, 17, 30).
export const TOAST_MS = 10000;
// The batch-reset step of the sync contract is allowed a fixed 10s (doc rev V4).
export const RESET_MS = 10000;

// Generic error toast copy — matches the Batch Execution dashboard wording.
export const GENERIC_ERROR = "Something went wrong. Please try again.";

// `batchResetFor` value sent to resetWorkflowPostGrn when the Sync SAP QA Check
// Interface button is clicked (PA10 / PA11). The backend keys the post-GRN
// workflow reset off this literal, so it must match exactly.
export const BATCH_RESET_FOR_QA_SAP_SYNC = "QA SAP Sync";

// Hardcoded "QA Release Status in SAP" copy shown on the QA release card. The SAP
// status is not carried per-batch on the read, so the field is derived from the
// pending action (PA10 pending / PA11 rejected) — see QAReleaseCard.
export const QA_STATUS_PENDING_TEXT = "Pending (Quality Inspection)";
export const QA_STATUS_REJECTED_TEXT = "Rejected (Blocked Stock)";

// Status-change polling now lives inside GRFeedbackContext and uses the
// lightweight A22 fetchBatchStatusDirect endpoint with backoff
// (2s→3s→5s→8s, hard cap 45s). The old table-refetch poll constants
// (STATUS_POLL_TRIES / STATUS_POLL_INTERVAL_MS) were removed — see
// GRFeedbackContext.pollUntilStatusChanges for the current schedule.
